import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import ViewJobCards from './pages/ViewJobCards';
import Login from './pages/Login';
import ReceptionDashboard from './pages/ReceptionDashboard';
import AudiologistDashboard from './pages/AudiologistDashboard';
import TechnicianDashboard from './pages/TechnicianDashboard';
import CreateJobCard from './pages/CreateJobCard';
import ViewTracking from './pages/ViewTracking';
import EditJobCard from './pages/EditJobCard';
import TrackStatusPage from './pages/TrackStatusPage';


// ✅ صفحة اختبار زر الرفع
const TestUploadPage = () => (
  <div style={{ padding: '2rem' }}>
    <h2>🧪 Test File Upload</h2>

  </div>
);

function App() {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userRef = doc(db, 'users', user.uid);
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          setUserRole(data.role);
          localStorage.setItem('userRole', data.role);
        } else {
          setUserRole(null);
        }
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (!userRole) return <Login />;

  return (
    <Routes>
      {/* الصفحة الرئيسية حسب الدور */}
      <Route
        path="/"
        element={
          userRole === 'reception' ? (
            <ReceptionDashboard />
          ) : userRole === 'audiology' ? (
            <AudiologistDashboard />
          ) : userRole === 'technician' ? (
            <TechnicianDashboard />
          ) : (
            <p>Unauthorized</p>
          )
        }
      />

      {/* صلاحية الإنشاء فقط للريسيبشن و الأوديولوجي */}
      {(userRole === 'reception' || userRole === 'audiology') && (
        <Route path="/create-job-card" element={<CreateJobCard />} />
      )}

      {/* عرض وتتبع الجوب كارد لجميع الأدوار */}
      {(userRole === 'reception' ||
        userRole === 'audiology' ||
        userRole === 'technician') && (
        <>
          <Route path="/view-job-cards" element={<ViewJobCards />} />
          <Route path="/track/:id" element={<ViewTracking />} />
          <Route path="/track-status" element={<TrackStatusPage />} />
        </>
      )}

      {/* صفحة التعديل فقط للأوديولوجي */}
      {userRole === 'audiology' && (
        <Route path="/edit-job-card/:id" element={<EditJobCard />} />
      )}

      {/* ✅ صفحة تجريبية لرفع الملفات */}
      <Route path="/test-upload" element={<TestUploadPage />} />

      {/* إعادة توجيه لأي مسار غير معروف */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
